import {IIncident, Impact} from "../../rz-status_models";
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm';
import remarkBreaks  from 'remark-breaks';

export default function({incident, worst = false, detail = false}: {incident: IIncident, worst?: boolean, detail?: boolean}) {
	return <article className="incident">
		<header>
			<div className="headline">{incident.serviceId.name}</div>
			<div><span className="label" >Beginn:</span> <DateElement date={incident.startDate}/></div>
			<div><span className="label" >Ende:</span> <DateElement date={incident.endDate}/></div>
			<div><span className="label" >Status:</span> <StateIcon state={worst ? incident.worstState : incident.currentState}/></div>
		</header>
		{(detail && incident.externalInfo) ? 
			<Markdown remarkPlugins={[remarkBreaks,remarkGfm]}>{incident.externalInfo}</Markdown>
		 : ""}
	</article>
}

function DateElement({date,}) {
    if ((!date) || (date == null) || (date.getTime() === 0) || (date.getFullYear() === 0))
        return <span className={"date nodate "}>-</span>;
	return  <span className={"date"}>{moment(date).local(true).format("DD.MM.YYYY / HH:mm")}</span>
}


function StateIcon({state} : {state: Impact}) {
	let stateString = "state_ok"
	if(state == Impact.Limited) {
		stateString = "state_problem"
	}
	else if(state == Impact.Outage) {
		stateString = "state_notok"
	}

	return <span className={"icon " + stateString}> </span>
}
